
import { defineComponent } from "vue";
import InfoBox from "./InfoBox.vue";

export default defineComponent({
  name: "List",
  components: { InfoBox },
  props: {
    max: {
      type: Number,
      default: null,
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
});
